import { IdResource } from "../../../constants/IdResource";
var resourcesWhichNeedMarket = [IdResource.Money];
export var checkEarnResourceTroughMarket = function (path) { return function (action, state$, dependencies) {
    return action.taskType &&
        action.taskType.resourceId &&
        resourcesWhichNeedMarket.indexOf(action.taskType.resourceId) >= 0
        ? path
        : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkEarnResourceTroughMarket.ts
// module id = 2363
// module chunks = 3